import axios from '../../../axiosReport';
import { toast } from 'react-toastify';

export const exportExcelFetching = async (config, data) => {
    const { url, method, headers, fileName, fileFormat } = config;

    try {
        const response = await axios({
            url: url,
            method: method,
            ...data,
            headers: headers,
            responseType: 'blob',
        });
        if (response && response?.type == 'application/octet-stream') {
            const href = URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = href;
            const date = new Date();
            const dateNow =
                ('0' + date.getHours()).slice(-2) +
                ('0' + date.getMinutes()).slice(-2) +
                ('0' + date.getDate()).slice(-2) +
                ('0' + (date.getMonth() + 1)).slice(-2) +
                ('0' + date.getFullYear()).slice(-2);
            link.setAttribute('download', `${fileName}${dateNow}.${fileFormat}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            const reader = new FileReader();
            reader.onload = () => {
                const result = JSON.parse(reader.result);
                if (result.status !== 401 && result.status !== 200) {
                    toast.error(result.message);
                }
            };
            reader.readAsText(response);
        }
    } catch (error) {
        console.log(error);
        toast.warning('Hệ thống đang bảo trì!');
    }
};

export const fetchingData = async (cb, returnCatch) => {
    try {
        let response = await cb();
        return response;
    } catch (error) {
        console.log(error);
        toast.warning('Hệ thống đang bảo trì!');
        return returnCatch;
    }
};
